export const createDate = (dateString: string): Date => {
  return new Date(dateString);
};
